import React, {useReducer, createContext} from 'react';

export const GlobalStateContext = createContext();
export const GlobalDispatchContext = createContext()

const initialState = {
    items: [],
    total: 0,
    orderModal: false,
    paymentData: null,
    paymentSuccess: false,
    isLoading: false,
    hideOverflow: false,
    hasDiscount: false,
    customerInfo: {
        firstName: '',
        surname: '',
        email: '',
        hasDiscount: false,
        subscribe: false
    },
    showSidebar: true,
    policyIsOpen: false,
    gdprIsOpen: true

};

function reducer(state = initialState, action) {
    switch (action.type) {
        case 'ADD_ITEM':
            const found = state.items.find(x => x.id === action.item.id);
            const increasedArray = state.items.map(item => {
                if (item.id === action.item.id) {
                    item.qty ++;
                    item.total = item.qty * item.price;
                }
                return item;
            })
            return {
                ...state,
                items: found ? [... increasedArray] : [
                    ...state.items,
                    action.item
                ]
            }
        case 'REMOVE_ITEM':
            return {
                ...state,
                items: state.items.filter(pack => {
                    return pack.id !== action.id
                })
            }
        case 'SHOW_SIDEBAR': 
            return {
                ...state,
                showSidebar: true
            }
        case 'HIDE_SIDEBAR': 
            return {
                ...state,
                showSidebar: false
            }
        case 'ADD_DISCOUNT':
            return {
                ...state,
                hasDiscount: true
            }
        case 'SET_TOTAL':
            return {
                ...state,
                total: action.total
            }
        case 'SHOW_ORDER_CONFIRM_MODAL':
            return {
                ...state,
                orderModal: action.isOpen,
                paymentData: action.data,
                paymentSuccess: action.success
            }
        case 'SHOW_LOADING':
            return {
                ...state,
                isLoading: action.isLoading
            }
        case 'HIDE_OVERFLOW':
            return {
                ...state,
                hideOverflow: action.hideOverflow
            }
        case 'UPDATE_QUANTITY':
            const updatedArray = state.items.map(item => {
                if (item.id === action.item.id) {
                    item.qty = action.qty;
                    item.total = action.qty * item.price;

                }
                return item;
            })
            return {
                ...state,
                item: [... updatedArray]

            }
        case 'CUSTOMER_INFO':
            return {
                ...state,
                customerInfo: action.customerInfo
            }
        case 'PURCHASE_COMPLETE': 
            return {
                ...state,
                items: [],
                customerInfo: {
                    firstName: '',
                    surname: '',
                    email: ''
                },
                hideOverflow: true,
                isLoading: false 
            }
        case 'SET_POLICY_OPEN': 
            return {
                ...state,
                policyIsOpen: action.policyIsOpen,
                gdprIsOpen: false
            }
        case 'SET_GDPR_OPEN': 
            return {
                ...state,
                gdprIsOpen: action.gdprIsOpen

            }
        default:
            throw new Error('Bad Action')
    }

}
const GlobalContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (<GlobalStateContext.Provider value={state}>
        <GlobalDispatchContext.Provider value={dispatch}> {children} </GlobalDispatchContext.Provider>

    </GlobalStateContext.Provider>)
}

export default GlobalContextProvider;
